import { render, staticRenderFns } from "./ModalConfirmDeleteV2.vue?vue&type=template&id=79dfcf42&scoped=true&"
import script from "./ModalConfirmDeleteV2.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmDeleteV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dfcf42",
  null
  
)

export default component.exports